import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ProductsSection from './components/ProductsSection';
import MediaSection from './components/MediaSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContractAwardsSection from './components/ContractAwardsSection';
import Footer from './components/Footer';
import AdminApp from './admin/AdminApp';

const MainWebsite = () => {
  return (
    <>
      <Navigation />
      <HeroSection />
      <ServicesSection />
      <ProductsSection />
      <MediaSection />
      <TestimonialsSection />
      <ContractAwardsSection />
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainWebsite />} />
          <Route path="/admin/*" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;